import { Injectable, inject } from '@angular/core';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { Gtm } from '@df/module-gtm/event/gtm.event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-remove-from-cart';

const quoteIdSessionKey = '_gtmQuoteId';

@Injectable({
    providedIn: 'root'
})
export class GtmEventRemoveFromCartTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Session storage service
     */
    private sessionStorageService = inject(SessionStorageService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'basketDataChange') {
                const quoteId = event.data.basket.data.quote_id;
                const sessionQuoteId = this.sessionStorageService.get(quoteIdSessionKey);
                if (quoteId !== sessionQuoteId) {
                    this.sessionStorageService.set(quoteIdSessionKey, quoteId);
                } else {
                    // only track when the same quote
                    const items = event.data.removedItems;
                    if (items) {
                        this.dispatch(
                            event,
                            items.map(i => ({ ...this.gtmDataService.basketItemToGtmItem(i.item), qty: i.qty }))
                        );
                    }
                }
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, changes: Gtm.BasketItem[]) {
        return this.gtmService.dispatch({
            event: 'remove_from_cart',
            triggerContext: {
                trigger
            },
            ecommerce: await this.gtmDataService.getEventData(changes)
        });
    }
}
